$shm_agent_message_chart $mol_view
	option null
	height 320
	style *
		^
		height <= height_style \320px
	sub /
		<= Chart $shm_echarts
			option <= option

